export default __webpack_public_path__ + "static/modelo-ruleta-792922b6aa0e1add25281b749eb24bf8.png";